import * as SpecTempService from '../../../../services/spec-template.service';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import {
  GET_ALL_GRADING,
  GET_SPEC_DETAIL,
  UNMOUNT_SPEC_TEMPLATE,
  GET_SPEC_LIBRARY_TEMPLATE,
  CLEAR_SPEC_REDUCER,
  GET_ALL_BRAND,
  GET_CATEGORY_ONE_DATA,
  GET_CATEGORY_TWO_DATA,
  GET_CATEGORY_THREE_DATA,
  GET_SPEC_DOCUMENT,
  GET_ALL_SPEC_TEMPLATE,
} from './SpecTemplate.type';

export const fetchAllGrading = (params) => async (dispatch) => {
  try {
    const res = await SpecTempService.getAllGrading(params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: GET_ALL_GRADING,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchGradingById = (params, id) => async () => {
  try {
    const res = await SpecTempService.getGradingById(params, id);
    if (res?.code === 200 && res.data) {
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSpecTemplate = (specObj) => async (dispatch) => {
  try {
    const res = await SpecTempService.getSpecTemplate(specObj);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: GET_SPEC_DETAIL,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateSpecDetail = (specId, data, t) => async () => {
  try {
    const res = await SpecTempService.updateSpecTemplate(specId, data);
    if (res?.code === 200 && res.data) {
      const msg = t(`SPEC_TEMP_LIBRARY.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const languageKey = mapBackendErrorToLanguageKey(res.data.errMsg);
      const msg = getErrorMessage(languageKey, t);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
    return res;
  } catch (err) {
    const errMsg = err?.response?.data?.data?.errMsg || err?.response?.data?.errMsg || err?.message || err.toString();
    const languageKey = mapBackendErrorToLanguageKey(errMsg);
    const msg = getErrorMessage(languageKey, t);
    toasterMsg(msg, 'danger');
    return { code: err?.response?.status || 500, message: errMsg };
  }
};
// BM-7946: Persist the rearranged POM sequence for a spec template without
// going through the full template save endpoint.
export const updateSpecTemplatePomSequence = (specId, payload, t) => async () => {
  try {
    const res = await SpecTempService.updateSpecTemplatePomSequence(specId, payload);
    if (res?.code === 200) {
      toasterMsg(t('SPEC_TEMP_LIBRARY.POM_SEQUENCE_UPDATED'), 'success');
      return res;
    }
    const errMsg = res?.data?.errMsg || res?.message;
    if (errMsg) toasterMsg(errMsg, 'danger');
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

const mapBackendErrorToLanguageKey = (backendError) => {
  const errorMap = {
    'BACKEND_SERVER.LIBRARIES_SERVICE.SPEC_TEMPLATE_CODE_ALREADY_EXISTS': 'SPEC_TEMP_LIBRARY.SPEC_CODE_ALREADY_EXISTS',
  };
  return errorMap[backendError] || backendError;
};

const getErrorMessage = (languageKey, t) => {
  const msg = t(languageKey);
  if (!msg || msg === languageKey) {
    if (languageKey.includes('SPEC_CODE_ALREADY_EXISTS')) {
      return 'Spec template with this code already exists. Please use a different code.';
    }
    return 'An error occurred. Please try again.';
  }
  return msg;
};

export const addSpecDetail = (data, t) => async () => {
  try {
    const res = await SpecTempService.saveSpecTemplate(data);
    if (res?.code === 200 && res.data) {
      const msg = t(`SPEC_TEMP_LIBRARY.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const languageKey = mapBackendErrorToLanguageKey(res.data.errMsg);
      const msg = getErrorMessage(languageKey, t);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
    return res;
  } catch (err) {
    const errMsg = err?.response?.data?.data?.errMsg || err?.response?.data?.errMsg || err?.message || err.toString();
    const languageKey = mapBackendErrorToLanguageKey(errMsg);
    const msg = getErrorMessage(languageKey, t);
    toasterMsg(msg, 'danger');
    return { code: err?.response?.status || 500, message: errMsg };
  }
};

export const unmountSpecTemplate = () => async (dispatch) => {
  try {
    await dispatch({
      type: UNMOUNT_SPEC_TEMPLATE,
      payload: null,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSpecLibraries = (params) => async (dispatch) => {
  try {
    const res = await SpecTempService.fetchSpecList(params);
    if (res?.code === 200) {
      await dispatch({
        type: GET_SPEC_LIBRARY_TEMPLATE,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: CLEAR_SPEC_REDUCER,
    });
    return true;
  } catch (error) {
    toasterMsg(error, 'danger');
  }
};

export const deleteSpecLibraries = (id, param, t) => async () => {
  try {
    const res = await SpecTempService.deleteSpecLibrary(id, param);
    if (res?.code === 200 && res.data) {
      const msg = t('SPEC_TEMP_LIBRARY.BACKEND_CONTROLLER.SPEC_TEMPLATE_LIBRARY_DELETED');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const MultiDeleteSpecLibraries = (payload, t) => async () => {
  try {
    const res = await SpecTempService.MultiDeleteSpecLibrary(payload);
    if (res?.code === 200 && res.data) {
      const msg = t('SPEC_TEMP_LIBRARY.BACKEND_CONTROLLER.SPEC_TEMPLATE_LIBRARY_DELETED');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const DuplicateSpecLibraries = (payload, t) => async () => {
  try {
    const res = await SpecTempService.duplicateSpecLibrary(payload);
    if (res?.code === 200 && res.data) {
      const msg = t('SPEC_TEMP_LIBRARY.BACKEND_CONTROLLER.DUPLICATE_SPEC_TEMPLATE');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(t(res.data.errMsg), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const fetchBrands = (params) => async (dispatch) => {
  try {
    const response = await SpecTempService.fetchBrand(params);
    if (response.code === 200) {
      await dispatch({
        type: GET_ALL_BRAND,
        payload: response.data,
      });
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const fetchCategoryOne = (params) => async (dispatch) => {
  try {
    const response = await SpecTempService.fetchCategory(params);
    if (response.code === 200) {
      await dispatch({
        type: GET_CATEGORY_ONE_DATA,
        payload: response.data,
      });
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};
export const fetchCategoryTwo = (params) => async (dispatch) => {
  try {
    const response = await SpecTempService.fetchCategory(params);
    if (response.code === 200) {
      await dispatch({
        type: GET_CATEGORY_TWO_DATA,
        payload: response.data,
      });
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const fetchCategoryThree = (params) => async (dispatch) => {
  try {
    const response = await SpecTempService.fetchCategory(params);
    if (response.code === 200) {
      await dispatch({
        type: GET_CATEGORY_THREE_DATA,
        payload: response.data,
      });
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};
export const saveSupportingDocument = (specId, data, t) => async () => {
  try {
    const res = await SpecTempService.saveSpecTemplateSupportingDocument(specId, data);
    if (res?.code === 200 && res.data) {
      const msg = t(`SPEC_TEMP_LIBRARY.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = t(`SPEC_TEMP_LIBRARY.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSpecDocument = (specId) => async (dispatch) => {
  try {
    const res = await SpecTempService.getSpecTemplateSupportingDocument(specId);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: GET_SPEC_DOCUMENT,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateDocuments = (data, t) => async () => {
  try {
    const res = await SpecTempService.updateSpecDocument(data);
    if (res?.code === 200 && res.data) {
      const msg = t(`SPEC_TEMP_LIBRARY.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = t(`SPEC_TEMP_LIBRARY.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteDocuments = (data, specId, t) => async () => {
  try {
    const res = await SpecTempService.deleteSpecTempDocument(data, specId);
    if (res?.code === 200 && res.data) {
      const msg = t(`SPEC_TEMP_LIBRARY.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = t(`SPEC_TEMP_LIBRARY.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const uploadPOMXlsxFile = (payload) => async () => {
  try {
    const res = await SpecTempService.uploadPOMXlsxFileService(payload);
    if (res?.code === 200 && res?.data) {
      return res?.data;
    }
    toasterMsg(res?.data?.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const retriveAllSpecTemplate = (selectedGradingLib) => async (dispatch) => {
  try {
    const res = await SpecTempService.retriveAllSpecTemplate(selectedGradingLib);
    if (res?.code === 200 && res?.data) {
      await dispatch({
        type: GET_ALL_SPEC_TEMPLATE,
        payload: res?.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addDocumentToLibrary = (data, t) => async () => {
  try {
    const res = await SpecTempService.addDocumentToLibrary(data);
    if (res?.code === 200 && res.data) {
      const msg = t(`SPEC_TEMP_LIBRARY.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = t(`MEASUREMENT.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const importDocumentToSpec = (data, t) => async () => {
  try {
    const res = await SpecTempService.importDocumentToSpec(data);
    if (res?.code === 200 && res.data) {
      const msg = t(`SPEC_TEMP_LIBRARY.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = res.data.errMsg;
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
